import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useCallback } from 'react';

import { createCheckoutSession } from '@/entities/payment/api';

// Stripe 초기화
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// 체크아웃 컴포넌트
export function CheckoutForm({
  workspaceId,
  productId,
  priceId,
}: {
  workspaceId: string;
  productId: string;
  priceId: string;
}) {
  const fetchClientSecret = useCallback(async () => {
    // 서버에서 클라이언트 시크릿 가져오기
    const clientSecret = await createCheckoutSession({
      workspaceId,
      productId,
      priceId,
    });
    return clientSecret;
  }, [workspaceId, productId, priceId]);

  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
